<template>
    <div class="c-menu-component"> 
        <a :href="'/'+lang+'/search'" class="navbar-toggler"  >
            <span class="material-icons text-dark">search</span>
        </a>
        <a v-if="auth" class="navbar-toggler" @click="toggleProfile()"  >
            <span v-if="!profile" class="material-icons text-dark">account_circle</span>
            <span v-else class="material-icons text-dark">close</span>
        </a>
        <a v-else :href="'/'+lang+'/login'" class="navbar-toggler"  >
            <span class="material-icons text-dark">account_circle</span>
        </a>
        <a class="navbar-toggler"  @click="toggle()">
            <span v-if="!opened" class="material-icons text-dark">menu</span>
            <span v-else class="material-icons text-dark">close</span>
        </a>
        
        <div v-show="opened" class="c-menu-expaneded">
            <h2 class="m-0 p-4 font-weight-bold">{{trans('More')}}</h2>
            <div class="c-menu-items">
                <a :href="'/'+lang+'/search'" class="c-menu-item" v-ripple>{{trans('Activities')}}</a>
                <a :href="'/'+lang+'/categories/unique-stays'" class="c-menu-item" v-ripple>{{trans('Stays')}}</a>
                <a :href="'/'+lang+'/gift-cards'" class="c-menu-item" v-ripple>{{trans('Gift Cards')}}</a>
                <a :href="'/'+lang+'/list-your-activity'" class="c-menu-item" v-ripple>{{trans('Become a Partner')}}</a>
            </div>

            <div class="c-menu-item font-weight-bold">{{trans('Language')}}</div>
            <div class="c-menu-items">
                <template v-for="(language, key) in JSON.parse(languages)">
                    <a :href="'/'+key+'/lang'" :key="key" v-if="lang != key" class="c-menu-item" v-ripple>{{trans(language)}}</a>
                </template>
            </div>

            <div class="c-menu-item font-weight-bold">{{trans('Help and support')}}</div>
            <div class="c-menu-items">
                <a href="/support" class="c-menu-item" v-ripple>{{trans('Customer Support')}}</a>
                <a href="/faq" class="c-menu-item" v-ripple>{{trans('FAQs')}}</a>
            </div>

            <div class="c-menu-item font-weight-bold">{{trans('Settings and legal')}}</div>
            <div class="c-menu-items">
                <a href="/about" class="c-menu-item" v-ripple>{{trans('About Tripsome')}}</a>
                <a href="/contact" class="c-menu-item" v-ripple>{{trans('Get in touch')}}</a>
                <a href="/terms" class="c-menu-item" v-ripple>{{trans('Terms of Service')}}</a>
                <a href="/privacy-policy" class="c-menu-item" v-ripple>{{trans('Privacy policy')}}</a>
            </div>
        </div>

        <div v-show="profile" class="c-menu-expaneded">
            <h2 class="m-0 p-4 font-weight-bold">{{trans('Profile')}}</h2>
            <div class="c-menu-items">
                <a v-if="user_type === 'organizer'" :href="'/'+lang+'/dashboard'" class="c-menu-item" v-ripple>{{trans('Dashboard')}}</a>
                <!-- Adding trans method on admin panel will make it disappear on mobiles don't add it, only admins will see this text -->
                <a v-if="user_type === 'admin'" :href="'/'+lang+'/admin'" class="c-menu-item" v-ripple>Admin panel</a>
                <a :href="'/'+lang+'/profile'" class="c-menu-item" v-ripple>{{trans('Profile')}}</a>
                <a :href="'/'+lang+'/bookings'" class="c-menu-item" v-ripple>{{trans('My orders')}}</a>
                <a :href="'/'+lang+'/children'" class="c-menu-item" v-ripple>{{trans('My children')}}</a>
                <a :href="'/'+lang+'/wallet'" class="c-menu-item" v-ripple>{{trans('Wallet')}}</a>
                <a :href="'/'+lang+'/moments'" class="c-menu-item" v-ripple>{{trans('Moments')}}</a>
                <a href="#" @click="logout" class="c-menu-item" v-ripple>{{trans('Logout')}}</a>
            </div>
        </div>
        <form ref="logout" :action="'/' + lang + '/logout'" method="POST" style="display: none;">
            <input type="hidden" name="_token" :value="csrf">
        </form>
    </div>
</template>

 <script>
 export default {
   props: ["lang", "auth", "csrf", "user_type", "languages"],
   data() {
    return {
     opened:false,
     profile:false,
    }
   },
   methods: {
        logout:function(){
            this.$refs.logout.submit();
        },
        toggle(){
            this.profile = false;
            if(this.opened){
                this.opened = false;
                document.documentElement.style.overflow = 'auto'
            }else{
                this.opened = true;
                document.documentElement.style.overflow = 'hidden'
            }
        },
        toggleProfile(){
            this.opened = false;
            if(this.profile){
                this.profile = false;
                document.documentElement.style.overflow = 'auto'
            }else{
                this.profile = true;
                document.documentElement.style.overflow = 'hidden'
            }
        }
    },
 }
 </script>